import React from 'react';
import PropTypes from 'prop-types';
import Header from './Header';
import Footer from './Footer';
import { BACKGROUND_BLACK } from '../styles/Colors';
import { HEADER_HIGHT } from '../styles/LayoutSetting';

const styles = {
  screenContainer: {
    minHeight: '100vh',
    backgroundColor: BACKGROUND_BLACK,
  },
  headerStyle: {
    position: 'fixed',
    top: 0,
    zIndex: 1,
    height: HEADER_HIGHT,
    width: '100%',
  },
  contentContainer: {
    // default display is 'block': It starts on a new line, and takes up the whole width
  },
  footerContainer: {
    // default display is 'block': It starts on a new line, and takes up the whole width
  },
};

const GeneralLayout = ({
  Child,
  isShowHeader,
  isShowFooter,
  ...otherProps
}) => (
  <div style={styles.screenContainer}>
    {isShowHeader && (
      <div style={styles.headerStyle}>
        <Header />
      </div>
    )}
    <div style={styles.contentContainer}>
      <Child
        {...otherProps}
      />
    </div>
    {isShowFooter && (
      <div style={styles.footerContainer}>
        <Footer />
      </div>
    )}
  </div>
);

GeneralLayout.propTypes = {
  Child: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]).isRequired,
  isShowHeader: PropTypes.bool,
  isShowFooter: PropTypes.bool,
};

GeneralLayout.defaultProps = {
  isShowHeader: true,
  isShowFooter: true,
};

export default GeneralLayout;
